import * as React from "react";

function ArrowToprightIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("polyline", {
    points: "48 28 48 16 36 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 16,
    x2: 16,
    y2: 48
  }));
}

export default ArrowToprightIcon;